import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { PURGE } from "redux-persist"
import { chatReplyKey, ComposerSurface } from "./chatRepliesSlice"
import type { MessageOptions } from "./chatsSliceThunks"
import type { RootState } from "./store"

export type ComposerDraft = { text: string; options: MessageOptions }

type ComposerDraftTarget = { chatJid: string; surface: ComposerSurface }

const initialState: Record<string, ComposerDraft> = {}

export const composerDraftsSlice = createSlice({
  name: "composerDrafts",
  initialState,
  reducers: {
    setComposerDraft: (
      state,
      action: PayloadAction<ComposerDraftTarget & { draft: ComposerDraft }>,
    ) => {
      const { chatJid, surface, draft } = action.payload
      state[chatReplyKey(chatJid, surface)] = draft
    },
    clearComposerDraft: (state, action: PayloadAction<ComposerDraftTarget>) => {
      delete state[chatReplyKey(action.payload.chatJid, action.payload.surface)]
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})

export const selectComposerDraft =
  (chatJid: string, surface: ComposerSurface) =>
  (state: RootState): ComposerDraft | undefined =>
    state.composerDrafts[chatReplyKey(chatJid, surface)]

export const { setComposerDraft, clearComposerDraft } =
  composerDraftsSlice.actions

export default composerDraftsSlice.reducer
